export default __webpack_public_path__ + "static/2-fc6b4e0ca23b80289b0cce60017b2dae.webp";